import React, { useState, useCallback } from 'react';
import { Button, DialogContent, DialogTitle, DialogActions, Dialog, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

function CreateNewActivityModal({ duplicateId = null, showModal, MODAL_TYPE }) {
    const [name, setName] = useState(null);
    const { notifySuccess, notifyError } = useNotify();
    const history = useHistory();

    const createActivity = useCallback(() => {
        const req =
            duplicateId === null
                ? doSwaggerCall('activities', 'createActivity', { activity: { name } })
                : // TODO: modify duplicate
                  doSwaggerCall('activities', 'duplicateActivity', {
                      activityId: duplicateId,
                      activity: { name }
                  });
        req.then(data => {
            notifySuccess('New activity created!');
            showModal(MODAL_TYPE.NONE);
            history.push(`/admin/activity/update/${data.id}`);
        }).catch(err => {
            console.log(err);
            notifyError('Error during activity creation!');
        });
    }, [name, notifySuccess, notifyError, showModal, history]);

    return (
        <form>
            <Dialog
                aria-labelledby="client-modal"
                open
                onClose={() => showModal(MODAL_TYPE.NONE)}
                maxWidth="md"
            >
                <DialogTitle>
                    {duplicateId === null ? 'Create new activity' : 'Duplicate activity'}
                </DialogTitle>
                <DialogContent>
                    <form
                        id="newactivity-form"
                        onSubmit={ev => {
                            ev.preventDefault();
                            createActivity();
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Name"
                                    type="text"
                                    value={name}
                                    onChange={ev => setName(ev.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!name}
                        type="submit"
                        form="newactivity-form"
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </form>
    );
}

export default CreateNewActivityModal;
